import React from 'react';
import styled from 'styled-components';
import { Flex } from '../shared/Flex';
import ErrorIcon from '../../assets/error-icon.svg';
import { theme } from '../../style/theme';

const Wrapper = styled(Flex)`
  position: absolute;
  bottom: ${theme.spacing[3]};
  left: ${theme.spacing[3]};
  right: ${theme.spacing[3]};
  min-height: 70px;
  justify-content: start;
  align-items: center;
  background: ${theme.colors.neutral.white};
  border: 1px solid ${theme.colors.status.error};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.lg};
  backdrop-filter: blur(20px);
  animation: slideUp 0.3s ease-out;
  z-index: 5;
  
  @keyframes slideUp {
    from {
      transform: translateY(100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 3px;
    background: ${theme.colors.status.error};
    border-radius: ${theme.borderRadius.lg} ${theme.borderRadius.lg} 0 0;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
  background: rgba(239, 68, 68, 0.1);
  border-radius: ${theme.borderRadius.lg};
  margin: ${theme.spacing[4]} 0 ${theme.spacing[4]} ${theme.spacing[4]};
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
  filter: hue-rotate(0deg) saturate(1.2);
`;

const Content = styled.div`
  flex: 1;
  padding: ${theme.spacing[4]} ${theme.spacing[4]} ${theme.spacing[4]} ${theme.spacing[3]};
`;

const Message = styled.div`
  font-size: ${theme.typography.fontSize.sm};
  color: ${theme.colors.neutral.gray800};
  line-height: ${theme.typography.lineHeight.normal};
  font-weight: ${theme.typography.fontWeight.medium};
`;

const ErrorAlert = ({ message }) => {
  if (!message) {
    return null;
  }

  return (
    <Wrapper>
      <IconWrapper>
        <Icon src={ErrorIcon} alt="Error" />
      </IconWrapper>
      <Content>
        <Message>{message}</Message>
      </Content>
    </Wrapper>
  );
};
export default ErrorAlert;
